export default "__VITE_ASSET__6140a785__"